import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AppEffects } from './effects/app.effects';
import { SelectionEffects } from './effects/selection.effects';
import { buttonsReducer, inRoomButtonsFeatureKey } from './stores/buttons/buttons.reducer';
import { LocationEffects } from './stores/locations/locations.effects';
import { inRoomLocationsFeatureKey, locationReducer } from './stores/locations/locations.reducer';
import { SignalrEffects } from './stores/messages/messages.effects';
import { inRoomSignalRFeatureKey, signalRReducer } from './stores/messages/messages.reducer';
import { MobileReservationEffects } from './stores/mobilereservation/mobilereservation.effects';
import { mobileReservationReducer } from './stores/mobilereservation/mobilereservation.reducer';
import { inRoomMobileReservationFeatureKey } from './stores/mobilereservation/mobilereservation.state';
import { RoomEffects } from './stores/rooms/rooms.effects';
import { inRoomRoomsFeatureKey, roomsReducer } from './stores/rooms/rooms.reducer';
import { inRoomUiFeatureKey, uiReducer } from './stores/ui/ui.reducer';
import { inRoomUserFeatureKey, userReducer } from './stores/user/user.reducer';
import { RoomConfigurationEffects } from './sub-features/room-info/room-configuration-store/room-configuration.effects';
import {
  inroomRoomConfigurationsKey as inRoomRoomConfigurationsKey,
  roomConfigurationsReducer,
} from './sub-features/room-info/room-configuration-store/room-configuration.reducer';
import { alarmReducer, inRoomAlarmFeatureKey } from './sub-features/room/alarm/alarm-store/alarm.reducer';
import { AttributesEffects } from './sub-features/room/attributes/attributes-store/attributes.effects';
import { attributesReducer } from './sub-features/room/attributes/attributes-store/attributes.reducer';
import { inRoomAttribuesFeatureKey } from './sub-features/room/attributes/attributes-store/attributes.state';
import { blindsReducer, inRoomBlindsFeatureKey } from './sub-features/room/blinds/blinds-store/blinds.reducer';
import { curtainsReducer, inRoomCurtainsFeatureKey } from './sub-features/room/blinds/curtains-store/curtains.reducer';
import {
  fanspeedReducer,
  inRoomFanspeedFeatureKey,
} from './sub-features/room/fanspeed/fanspeed-store/fanspeed.reducer';
import { inRoomLightFeatureKey, lightReducer } from './sub-features/room/lights/lights-store/lights.reducer';
import { inRoomMediaStateFeatureKey, mediaReducer } from './sub-features/room/media/media.reducer';
import { inRoomMoviesFeatureKey, moviesReducer } from './sub-features/room/media/movie/movies.reducer';
import {
  inRoomRadioChannelsFeatureKey,
  radioChannelReducer,
} from './sub-features/room/media/radio-channel/radio-channels.reducer';
import { inRoomTvChannelsFeatureKey, tvChannelReducer } from './sub-features/room/media/tv-channel/tv-channels.reducer';
import { MobileFolioEffects } from './sub-features/room/mobilefolio/mobilefolio-store/mobilefolio.effects';
import { mobileFolioReducer } from './sub-features/room/mobilefolio/mobilefolio-store/mobilefolio.reducer';
import { inRoomMobileFolioFeatureKey } from './sub-features/room/mobilefolio/mobilefolio-store/mobilefolio.state';
import {
  inRoomTemperatureFeatureKey,
  temperatureReducer,
} from './sub-features/room/temperature/temperature-store/temperature.reducer';

export const provideInroomStores = () => [
  provideState(inRoomLocationsFeatureKey, locationReducer),
  provideState(inRoomUiFeatureKey, uiReducer),
  provideState(inRoomSignalRFeatureKey, signalRReducer),
  provideState(inRoomAlarmFeatureKey, alarmReducer),
  provideState(inRoomMediaStateFeatureKey, mediaReducer),
  provideState(inRoomRoomsFeatureKey, roomsReducer),
  provideState(inRoomMoviesFeatureKey, moviesReducer),
  provideState(inRoomRadioChannelsFeatureKey, radioChannelReducer),
  provideState(inRoomTvChannelsFeatureKey, tvChannelReducer),
  provideState(inRoomFanspeedFeatureKey, fanspeedReducer),
  provideState(inRoomTemperatureFeatureKey, temperatureReducer),
  provideState(inRoomButtonsFeatureKey, buttonsReducer),
  provideState(inRoomCurtainsFeatureKey, curtainsReducer),
  provideState(inRoomBlindsFeatureKey, blindsReducer),
  provideState(inRoomLightFeatureKey, lightReducer),
  provideState(inRoomUserFeatureKey, userReducer),
  provideState(inRoomRoomConfigurationsKey, roomConfigurationsReducer),
  provideState(inRoomMobileFolioFeatureKey, mobileFolioReducer),
  provideState(inRoomAttribuesFeatureKey, attributesReducer),
  provideState(inRoomMobileReservationFeatureKey, mobileReservationReducer),
  provideEffects([
    SelectionEffects,
    AppEffects,
    SignalrEffects,
    RoomEffects,
    LocationEffects,
    RoomConfigurationEffects,
    MobileFolioEffects,
    AttributesEffects,
    MobileReservationEffects,
  ]),
];
